const addEvent = (
  state: any = {
    city: '',
    contact_name: '',
    country: 'CA',
    description: '',
    email: '',
    end_date: '',
    is_ongoing: false,
    province: '',
    seqn: '',
    start_date: '',
    url: '',
    venue: '',
    volunteers_needed: ''
  },
  action: any
) => {
  switch (action.type) {
    case 'ADD_EVENT_REQUESTED':
      return {
        ...state,
        status: 'loading'
      }
    case 'ADD_EVENT_ERROR':
      return {
        ...state,
        status: 'Error',
        error: action.payload
      }
    case 'ADD_EVENT_SUCCESS':
      return {
        ...state,
        data: action.payload,
        status: 'success'
      }
    default:
      return state
  }
}

export default addEvent
